import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Loader from '../../components/common/Loader';
import { logout } from '../auth/authReducer';
import { redirectToAuth } from '../../helpers/auth';
import AuthRequired from './AuthRequired';

/**
 * Rendered for an internal (SSO) user whose tab has no usable token, e.g. a deep link
 * opened in a new tab that never inherited the per-tab sessionStorage auth state. Sends
 * the browser through advertising-apps-auth and back to the page it was asked to open.
 *
 * The redirect fires from an effect, never during render, and only once per tab: if the
 * loop guard is already tripped (this tab already tried this and came back with no
 * token), it renders AuthRequired instead of bouncing again. Until the effect decides
 * which of those two outcomes applies, this renders a spinner so there is never a flash
 * of an error page.
 */
const SsoReauth = () => {
    const dispatch = useDispatch();
    const [blocked, setBlocked] = useState(false);

    useEffect(() => {
        // Unconditional, before the loop guard check. verifyToken() has already told the
        // caller there is no usable token in this tab, so there is nothing worth keeping;
        // letting a stale/expired token survive into the blocked state would 401 every
        // request this app makes once it renders again.
        dispatch(logout());

        if (!redirectToAuth()) {
            setBlocked(true);
        }
    }, []);

    if (blocked) {
        return <AuthRequired />;
    }

    return <Loader show={true} />;
};

export default SsoReauth;
